document.addEventListener("DOMContentLoaded", function () {
    document.querySelector('.menu-toggle').addEventListener('click', function () {
        document.querySelector('.gh-head-menu ul').classList.toggle('show-menu');
    });
});
